import f3tch from 'f3tch';

import profile from '../../api/profiles/json.profile.api';

export default (tagId, tag) =>
  f3tch(`/crm/tags/${tagId}/`).profile(profile()).body(tag).patch();
